module.exports = __webpack_public_path__ + "static/erinyes-8cc468182fcbce2dae274845035d866a.jpeg";